import './bootstrap';

// Externals
import '@wwdev/bootstrap/index.js';
import '@wwdev/functions/index.js';
import './wwdev/forms/index';
import '@fancyapps/fancybox';
import './wwdev/lazysizes/index.js';
import './wwdev/webshop/index.js';
import '@wwdev/myaccount/index.js';
import '@wwdev/register';
import '@wwdev/search';
import './template';
import './externals/hamburgers.js';

// Components
import './components';

// Vendor
import './vendor/Product/ProductDetail'
